<template>
  <ProjectFeature class="delta-feature" left-background-image="/assets/delta/delta-bg.webp" right-background-color="#003366" left-border-right="#062b4e 8px solid">
    <template #left-header>
      <div class="feature-logo">
        <img src="/assets/delta/feature-title.webp" alt="New Delta Sky Club" />
      </div>
    </template>

    <template #left-subtitle>
      <div class="subtitle"><h3>Digital Immersion Wall Powered by Zenapptic</h3></div>
    </template>

    <template #left-body>
      <div class="feature-list">
        <ul>
          <li>Launched a next-level immersive experience at Delta’s Sky Club SLC, where the LED wall becomes a real-time 3D world</li>
          <li>Brought 9 Utah national parks to life with dynamic weather, topical elements, and evolving AI-generated playlists</li>
          <li>Combined photo-realistic visuals, 3D spatial audio, and real-time animations for an atmosphere unlike any airport lounge</li>
        </ul>

        <div class="delta-logo">
          <img src="/assets/delta/delta-logo.webp" alt="Delta Logo" />
        </div>
      </div>
    </template>

    <template #right-media>
      <div class="video-container">
        <ProjectFeatureMedia class="delta-video-player" video-url="/assets/delta/Delta_Official_Video.webm" placeholder-text="Check it out" poster="/assets/delta/video-poster.webp">
          <img class="video-preview" src="/assets/delta/video-poster.webp" alt="Delta Sky Club digital immersion wall video preview" />
        </ProjectFeatureMedia>
      </div>
    </template>
  </ProjectFeature>
</template>

<style lang="scss">
.delta-feature {
  .project-feature__left {
    gap: 2rem;
    padding-top: 2rem;

    @media (max-width: 767px) {
      border-width: 0;
      gap: 1rem;
    }
  }

  .project-feature__right {
    @media (max-width: 1024px) {
      overflow: visible;
    }
  }

  .feature-logo {
    padding: 5rem 0 0;

    @media (max-width: 767px) {
      padding: 2rem 0 0;
    }

    img {
      width: 100%;
    }
  }

  .subtitle {
    h3 {
      background-color: rgba(6, 43, 78, 0.8);
      display: inline-block;
      padding: 1rem 5rem 1rem 2rem;

      @media (max-width: 767px) {
        margin: 0;
        padding: 1rem 3rem;
      }
    }
  }

  .feature-list {
    background-color: rgba(6, 43, 78, 0.8);
    padding: 2rem 2rem 2rem 1rem;

    @media (max-width: 767px) {
      padding: 2rem 1rem 2rem 0.25rem;
    }

    ul {
      display: flex;
      flex-direction: column;
      font-weight: 500;
      gap: 3rem;

      @media (max-width: 767px) {
        font-size: 1.9rem;
        gap: 2rem;
      }
    }
  }

  .delta-logo {
    text-align: right;

    @media (max-width: 767px) {
      text-align: center;
    }
  }

  .video-container {
    flex: 1 1 auto;
    height: auto;
    max-width: 100%;
    min-height: 0;
    position: relative;

    .delta-video-player {
      height: 100%;
      max-width: none;
      width: 100%;
    }

    .video-placeholder {
      height: 100%;
      max-width: none;
      width: 100%;
    }

    .video-preview {
      display: block;
      height: 100%;
      min-height: 0;
      object-fit: cover;
      pointer-events: none;
      width: 100%;
    }
  }
}
</style>
